<template>
  <!-- error tags -->
  <div class="error-inline" v-if="type === 'error'">
    <q-icon
      name="warning_amber"
      class="text-red-600 mr-1"
      :size="(iconSizePx ? iconSizePx : '18') + 'px'"
    />
    <div :class="`text-slate-600 font-medium text-small ${style}`">
      {{ title }}
    </div>
  </div>
  <div class="warning-inline" v-else-if="type === 'warning'">
    <q-icon
      name="info_outline"
      class="text-yellow-500 mr-1"
      :size="(iconSizePx ? iconSizePx : '18') + 'px'"
    />
    <div :class="`text-slate-600 font-medium text-small ${style}`">
      {{ title }}
      <span
        class="underline cursor-pointer"
        @click="emit('errorInlineEvent')"
        >{{ btnName }}</span
      >
    </div>
  </div>
  <div class="info-inline" v-else-if="type === 'info'">
    <q-icon
      name="info_outline"
      class="text-blue-400 mr-1"
      :size="(iconSizePx ? iconSizePx : '18') + 'px'"
    />
    <div :class="`text-slate-600 font-medium text-small ${style}`">
      {{ title }}
    </div>
  </div>
</template>
<script setup lang="ts">
import { ErrorTypes } from 'src/core/types/error';

defineProps<{
  title: string;
  type: ErrorTypes;
  style?: string;
  iconSizePx?: number;
  btnName?: string;
}>();
const emit = defineEmits<{
  (event: 'errorInlineEvent'): void;
}>();
</script>
<style lang="scss">
.error-inline {
  @apply bg-red-100 border border-red-300 rounded-lg items-center p-1.5 inline-flex;
}
.warning-inline {
  @apply bg-yellow-100 border border-yellow-300 rounded-lg items-center p-1.5 inline-flex;
}
.info-inline {
  @apply bg-blue-100 border border-blue-300 rounded-lg items-center p-1.5 inline-flex;
}
</style>
